import { finish, error } from '../../../modules/tags/actions/query';
import api from '../../../api';

export function request(dispatch, { id, data }) {
    console.trace('Get all tags reducers');
    // TODO: temporary for tags management tab
    $appState.sdkStaff.getAllTags()
        .then(tags => dispatch(finish(id, tags.definitions)))
        .catch( error => dispatch(error(id, error)));
    // api.get('/tags', void 0, {
    //     cache: 1000,
    //     headers: {
    //         'Cache-Control': data && data.cache ? 'public,max-age=3600' : 'no-cache, must-revalidate'
    //     }
    // }).then(
    //     ({ definitions }) => {
    //         dispatch(finish(id, definitions));
    //     },
    //     ({ errors }) => dispatch(error(id, errors))
    // );
}
